import type {ListenerEffectAPI} from "@reduxjs/toolkit";

import chapterCompleted from "../chapters/chapterCompleted";
import {keyProvider} from "../keyProvider";
import type {AppDispatch, RootState} from "../store";
import {submitChapterSession} from "./submitChapterSession";

function listener(
	action: ReturnType<typeof submitChapterSession.fulfilled>,
	api: ListenerEffectAPI<RootState, AppDispatch>
) {
	api.dispatch(
		chapterCompleted({
			chapterKey: keyProvider.chapter(action.meta.arg.chapterId),
		})
	);
}

export default listener;
